import { normalizeCommonFields, createActualBlockName } from '../common';
import { createConditionParamsActualNameBase } from '../../condition';

import { InputCommentAddNormalizer } from './client';

export const normalizeInputCommentAdd: InputCommentAddNormalizer = (
  raw,
  stores
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createConditionParamsActualNameBase({
          rootStore: stores.rootStore,
          messageConditions: {
            conditions: raw.params.message_conditions,
            mode: raw.params.message_conditions_mode
          },
          sqConditions: {
            conditions: raw.params.sq_conditions,
            mode: raw.params.sq_conditions_mode
          },
          varConditions: {
            conditions: raw.params.vars_conditions,
            mode: raw.params.vars_conditions_mode
          },
          t
        }),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
